import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import firebase from "firebase/app";
import "firebase/database";
import router from "./router";
import Transition from "./js/Transition/Controller.es6";
import store from "./store/index.js";

const firebaseConfig = {
  apiKey: "AIzaSyDqa963uDCe2KyTzoDd5clNGGh1vEGh6ik",
  authDomain: "showcase-balance.firebaseapp.com",
  databaseURL: "https://showcase-balance.firebaseio.com",
  projectId: "showcase-balance",
  storageBucket: "",
  messagingSenderId: "53408303298",
  appId: "1:53408303298:web:631cfadc172f9f0568d35b"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
require("./css/style.scss");

// globalオブジェクト
if (window.gb === undefined) window.gb = {};

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",

  created: function() {},
  mounted: function() {}
});

// leave ガード
router.beforeEach((to, from, next) => {
  const transition = new Transition();
  transition.hide(from.name, to.name, next);
});

// enter ガード
router.afterEach((to, from) => {
  const transition = new Transition();
  transition.show(to.name, from.name);
});



// WEBPACK FOOTER //
// ./src/main.js